import { getBackendUrls } from "@/config/getBackendUrls";
import { getSelectedSessionId } from "@/sdk";
import { getSharedApiClient } from "@/shared-utils";

export const getCustomerDetailsApi = () => {
    return getSharedApiClient(getSelectedSessionId()).extend(() => ({
        prefix: `${getBackendUrls().apiBaseUrl}/api/customer`,
    }));
};
